import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "c-tag-select" }
const _hoisted_2 = {
  key: 1,
  class: "tag-groups-container"
}

import { OfficePlusTag, OfficeplusHttpService } from '@/services/officeplus-http.service';
import { useReflectiveInjector } from '@tanbo/vue-di-plugin';
import { computed, reactive, ref } from 'vue';
import PriorityItem from './priorityItem.vue'
import CascadingSelect from '@/views/officeplus/_components/cascadingSelect/cascadingSelect.vue';

  
export default /*#__PURE__*/_defineComponent({
  props: {
    categoryId: Number,
    subCategoryId: Number,
    thirdCategoryId: Number,
    tagIds: String
  },
  emits: ['change'],
  setup(__props, { emit }) {

const props = __props

const injector = useReflectiveInjector([OfficeplusHttpService])
  const service = injector.get(OfficeplusHttpService)
  

  const categoryMap = {
    PPT: 10000,
    PPTSingle: 40000,
    PPTTheme: 50000,
    WORD: 20000,
    EXCEL: 30000
  }

  

  const defaultTagsId = computed(() => {
    return props.tagIds ? props.tagIds.split(',').map(item => Number(item)) : []
  })

  const viewModel = reactive({
    firstCategory: [],
    secondCategory: [],
    thirdCategory: [],
    tagGroups: [] as OfficePlusTag[],
    tags: []
  })

  // 二级分类选中值，用于控制级联选择器的重置
  const secondCategorySelectedValue = ref<number[]>([])
  const formParams = reactive({
    subCategoryId: null,
    categoryId: null,
    categoryPath: '',
    tagsId: [],
    tagsName: []
  })
  const tagData: Record<number, any> = {}

  // 初始化
  initFirstCategory()

  // 初始化一级分类
  function initFirstCategory () {
    service.getCategoryTree().then(res => {
      const PPTList = [categoryMap.PPT, categoryMap.PPTSingle, categoryMap.PPTTheme]
      // 初始化一级分类
      if (PPTList.includes(props.categoryId)) {
        viewModel.firstCategory = res.data.filter(item => PPTList.includes(item.id))
      } else {
        viewModel.firstCategory = res.data.filter(item => item.id === props.categoryId)
      }

      // 使用props传入的subCategoryId或默认值
      if (props.categoryId) {
        formParams.categoryId = props.categoryId
      } else if (viewModel.firstCategory.length > 0) {
        formParams.categoryId = viewModel.firstCategory[0].id
      } else {
        // 如果没有一级分类数据，设置为默认值
        formParams.categoryId = categoryMap.PPT // 使用默认的PPT分类
      }

      // 初始化二级分类
      initSecondCategory()
    })
  }

  /** 处理一级分类变化 */
  function onFirstCategoryChange() {
    // 清除二级和三级分类数据
    clearSecondCategorySelection()
    clearThirdCategoryData()

    // 重新初始化二级分类，并指定是由一级分类变化触发的
    initSecondCategory(true)

    // 更新表单数据
    updateFormData()
  }

  /** 初始化二级分类 */
  function initSecondCategory (isFromFirstCategoryChange = false) {
    // 初始化二级分类
    viewModel.secondCategory = viewModel.firstCategory.find(item => item.id === formParams.categoryId)?.children || []
    // 只有在非一级分类变化触发的情况下，才处理三级分类初始化
    if (!isFromFirstCategoryChange && props.thirdCategoryId && viewModel.secondCategory.length > 0) {
      // 查找包含thirdCategoryId的路径
      let path = null;
      let categoryId = null;
      let thirdCategoryId = null;

      // 遍历寻找路径
      const findPath = (nodes, targetId, currentPath = []) => {
        for (const node of nodes) {
          // 当前路径
          const newPath = [...currentPath, node.id];

          // 找到目标节点
          if (node.id === targetId) {
            return newPath;
          }

          // 递归查找子节点
          if (node.children && node.children.length > 0) {
            const result = findPath(node.children, targetId, newPath);
            if (result) return result;
          }
        }
        return null;
      };

      // 查找路径
      path = findPath(viewModel.secondCategory, props.thirdCategoryId);
      if (path) {
        // 设置二级分类选中值
        secondCategorySelectedValue.value = path;
        categoryId = path[0];
        thirdCategoryId = path[1];
        formParams.subCategoryId = categoryId;
        formParams.thirdCategoryId = thirdCategoryId;

        // 获取标签组数据
        service.getDetailCategory(thirdCategoryId).then(res => {
          viewModel.tagGroups = res.data || [];

          // 初始化标签
          initTags();

          updateFormData();
        });

        // 初始化完成，直接返回
        return;
      }
    }

    // 如果没有thirdCategoryId或未找到路径，清除状态
    clearSecondCategorySelection()
    clearThirdCategoryData()
    updateFormData()
  }

  function handleSecondCascadingSelectChange(result) {
    // 处理二级分类 - 级联选择变化
    if (result.id) {
      // 设置选中的分类
      formParams.subCategoryId = result.ids[0];
      formParams.thirdCategoryId = result.ids[1];
      formParams.categoryPath = result.path;

      // 更新二级分类选中值
      secondCategorySelectedValue.value = result.ids || [];

      // 清除三级分类数据
      clearThirdCategoryData()

      // 获取对应的标签组
      service.getDetailCategory(result.id).then(res => {
        viewModel.tagGroups = res.data || [];

        // 初始化标签
        initTags();

        updateFormData();
      })
    } else {
      // 清空标签组和选中的标签
      clearSecondCategorySelection();
      clearThirdCategoryData();

      updateFormData();
    }
  }

  /** 处理标签组选择变化 */
  function handleTagGroupChange(result, tagGroupId) {
    // 存储选中的标签到tagData中
    if (result.id) {
      tagData[tagGroupId] = {
        id: tagGroupId,
        tagsId: [result.id],
        tagsName: [result.path]
      };
    } else if (tagData[tagGroupId]) {
      // 如果取消选择，删除该标签组的数据
      delete tagData[tagGroupId];
    }

    updateFormData();
  }

  /** 更新表单数据并触发change事件 */
  /** 清除二级分类选择状态 */
  function clearSecondCategorySelection() {
    // 清空二级分类选择
    formParams.subCategoryId = null;
    formParams.categoryPath = '';

    // 重置级联选择器的选中状态
    secondCategorySelectedValue.value = [];
  }

  /** 获取标签组的默认选中值 */
  function getDefaultTagsForGroup(groupId) {
    // 检查标签组是否在tagData中存在
    if (tagData[groupId] && tagData[groupId].tagsId && tagData[groupId].tagsId.length > 0) {
      // 根据该组的选中标签找到完整路径
      const findPathsForTags = (groupId, tagIds) => {
        const result = [];
        const targetGroup = viewModel.tagGroups.find(group => group.id === groupId);
        if (!targetGroup) return result;

        // 递归查找标签路径
        const findTagPath = (nodes, targetId, currentPath = []) => {
          for (const node of nodes) {
            const newPath = [...currentPath, node.id];

            if (node.id === targetId) {
              return newPath;
            }

            if (node.children && node.children.length > 0) {
              const path = findTagPath(node.children, targetId, newPath);
              if (path) return path;
            }
          }
          return null;
        };

        // 为每个选中的标签查找路径
        tagIds.forEach(tagId => {
          const path = findTagPath(targetGroup.tags, tagId);
          if (path) result.push(path);
        });

        return result;
      };

      // 根据选中的标签找到路径
      const paths = findPathsForTags(groupId, tagData[groupId].tagsId);

      // 返回第一个有效路径，或空数组
      return paths.length > 0 ? paths[0] : [];
    }

    return [];
  }

  /** 初始化标签选择 */
  function initTags() {
    if (props.tagIds) {
      const tagIdsArray = props.tagIds.split(',').map(id => Number(id));
      formParams.tagsId = tagIdsArray;

      // 如果有标签组数据，将标签添加到tagData中
      if (viewModel.tagGroups.length > 0 && tagIdsArray.length > 0) {
        // 遍历每个标签组
        viewModel.tagGroups.forEach(tagGroup => {
          // 在标签组中查找选中的标签
          const findSelectedTag = (nodes, ids) => {
            for (const node of nodes) {
              if (ids.includes(node.id)) {
                // 找到选中的标签，添加到tagData
                tagData[tagGroup.id] = tagData[tagGroup.id] || {
                  id: tagGroup.id,
                  tagsId: [],
                  tagsName: []
                };
                tagData[tagGroup.id].tagsId.push(node.id);
                tagData[tagGroup.id].tagsName.push(node.name);
              }

              // 递归查找子节点
              if (node.children && node.children.length > 0) {
                findSelectedTag(node.children, ids);
              }
            }
          };

          // 在当前标签组中查找选中的标签
          findSelectedTag(tagGroup.tags, tagIdsArray);
        });
      }
    }
  }

  /** 清除三级分类数据 */
  function clearThirdCategoryData() {
    // 清空标签组
    viewModel.tagGroups = [];
    // 清空选中的标签
    formParams.tagsId = [];
    formParams.tagsName = [];
    // 清空标签数据缓存
    Object.keys(tagData).forEach(key => delete tagData[key]);
  }

  /** 更新表单数据并触发change事件 */
  function updateFormData() {
    const newData = Object.values(tagData).reduce((obj, item) => {
      obj.tagsId = obj.tagsId.concat(item.tagsId)
      obj.tagsName = obj.tagsName.concat(item.tagsName)
      return obj
    }, {tagsId: [], tagsName: []})

    emit('change', {
      subCategoryId: formParams.subCategoryId,
      l1_category_id: formParams.categoryId,
      l2_category_id: formParams.subCategoryId,
      l3_category_id: formParams.thirdCategoryId,
      categoryId: formParams.categoryId,
      categoryPath: formParams.categoryPath,
      ...newData
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_radio_group, {
      modelValue: _unref(formParams).categoryId,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formParams).categoryId) = $event)),
      onChange: onFirstCategoryChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel).firstCategory, (item) => {
          return (_openBlock(), _createBlock(_component_el_radio, {
            key: item.id,
            label: item.id
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(viewModel).secondCategory.length > 0)
      ? (_openBlock(), _createBlock(CascadingSelect, {
          key: `second-category-${_unref(formParams).subCategoryId}`,
          title: "选择分类",
          "tree-nodes": _unref(viewModel).secondCategory,
          "default-value": secondCategorySelectedValue.value,
          "menu-height": 400,
          onChange: handleSecondCascadingSelectChange
        }, null, 8, ["tree-nodes", "default-value"]))
      : _createCommentVNode("", true),
    (_unref(viewModel).tagGroups.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel).tagGroups, (tagGroup) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tagGroup.id,
              class: "tag-group-item"
            }, [
              _createVNode(CascadingSelect, {
                title: tagGroup.name,
                "tree-nodes": tagGroup.tags,
                "default-value": getDefaultTagsForGroup(tagGroup.id),
                "menu-height": Math.min(400, tagGroup.tags.length * 34 + 12),
                onChange: (result) => handleTagGroupChange(result, tagGroup.id)
              }, null, 8, ["title", "tree-nodes", "default-value", "menu-height", "onChange"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})